import * as classNames from 'classnames';
import * as React from 'react';

const Button: React.SFC<IButtonProps> =
  ({children, primary, secondary, submit, className, title, isDisabled, onClick}) => (
    <button onClick={onClick}
            title={title}
            // style={{width: '75px'}}
            disabled={isDisabled}
            className={classNames('button', className, {primary, secondary, disabled: !onClick})}
            type={submit ? 'submit' : 'button'}>
      {children}
    </button>
  );

interface IButtonProps {
  children: JSX.Element | string;
  primary?: boolean;
  secondary?: boolean;
  submit?: boolean;
  className?: string;
  isDisabled?:boolean;
  title?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

Button.defaultProps = {
  primary: false,
  secondary: false,
  submit: false,
  isDisabled: false
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/widgets/Button/index.tsx